import PrefectureForm from "../components/PrefectureForm";
import { message } from 'antd'
import service from "../../../../@services"


const PrefectureCreate = (props => {

    const fn = (params) => {
        return service.prefecture.mallZoneCreate(params).then(res => {
            props.history.go(-1)
            message.success("新增成功")
        }).catch(err => {
            return Promise.resolve(true)
        })
    }

    return (
        <PrefectureForm action="create" title='新增专区' fn={fn} />
    );
})

export default PrefectureCreate